'use strict';

import _ from 'underscore';
import $ from 'jquery';
import 'remodal';
import Backbone from 'backbone';
import $global from '../globalElements';
import config from '../config';
import mediator from '../mediator';

const ModalView = Backbone.View.extend({

  initialize: function(options) {
    _.bindAll(this, 'modalOpening', 'modalClosing', 'onOpen', 'onClose', 'onConfirm', 'onCancel', 'open', 'close');

    let remodalOptions;

    if (options) {
      this.template = options.template;
      this.content = options.content;
      remodalOptions = options.remodal
    }

    options = _.defaults(remodalOptions || {}, {
      hashTracking: false,
      closeOnConfirm: false,
      closeOnCancel: false
    });

    this.modal = this.$el.remodal(options);

    this.$el.on('opening', this.modalOpening);
    this.$el.on('closing', this.modalClosing);
    this.$el.on('opened', this.onOpen);
    this.$el.on('confirmation', this.onConfirm);
    this.$el.on('cancellation', this.onCancel);
    this.$el.on('closed', this.onClose);

  },

  modalOpening: function() {
    mediator.trigger(config.events.modal.opening, {});
    _.defer(function() {
      // Get the scrollbar offset placed by the remodal plugin
      var scrollBar = parseInt($global.$body.css('padding-right'), 10);

      // Shift the fixed header half of this to stop it jumping when the scrollbars are removed
      $('.Head').css({
        left: scrollBar / -2
      });
    });
  },

  modalClosing: function() {
    mediator.trigger(config.events.modal.closing, {});
    // Shift the fixed header back
    $('.Head').css({
      left: 0
    });
  },

  render: function() {
    if (this.template) {
      let data = this.modalData || {};
      data.analyticsConfig = config.analytics;
      this.$el.html(this.template(data));
    } else {
      this.$el.html(this.content);
    }
    return this;
  },

  open: function(data) {
    this.modalData = data;
    this.render();
    if (this.modal.getState() !== 'opened') {
      this.modal.open();

      // Fix for the overlay disappearing when another dialog
      // is opened before the first gets a chance to close
      _.delay(_.bind(function() {
        //Checking for the state of the modal after the delay, if it's closed, then don't show the overlay
        //it could be closed at this point if the user double-clicks and the modal closes before the overlay has a chance to display
        if (this.modal.getState() === 'opened') {
          this.modal.$overlay.show();
        }
      }, this), 200);
    }
  },

  close: function(reason) {
    this.modal.close(reason);
  },

  onOpen: function() {
  },

  onClose: function() {
  },

  onConfirm: function() {
    this.trigger('confirm');
    this.close('confirmation');
  },

  onCancel: function() {
    this.trigger('cancel');
    this.close('cancellation');
  }

});

module.exports = ModalView;



// WEBPACK FOOTER //
// ./assets/js/components/ModalView.js